<div class="location-map-container">
  <!-- Map Loading State -->
  @if (!mapLoaded && !mapError) {
    <div class="map-loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading map...</span>
      </div>
      <p class="text-muted mt-3">Loading map...</p>
    </div>
  }

  <!-- Map Error State -->
  @if (mapError) {
    <div class="map-error">
      <i class="fa fa-exclamation-triangle text-warning fs-2x mb-3"></i>
      <p class="text-muted">{{ mapError }}</p>
    </div>
  }

  <!-- Map Container -->
  <div
    #mapContainer
    class="map-element"
    [style.height]="getMapHeight()"
    [class.hidden]="!mapLoaded || mapError"
  ></div>

  <!-- Geocoding in Progress -->
  @if (loading && mapLoaded) {
    <div class="geocoding-progress">
      <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
      <span>Finding locations...</span>
    </div>
  }
</div>
